export const search =
  'M109 41c-38 0-69 32-69 71s31 70 69 70 69-31 69-70-31-71-69-71ZM0 112C0 50 49 0 109 0c61 0 110 50 110 112 0 22-7 43-18 61l49 48c8 7 8 20 0 29-7 8-20 8-28 0l-49-47c-18 13-40 21-64 21C49 224 0 174 0 112Zm0 0'
